export enum PositionsToast {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
}
